import { NearMissCategoryListTable } from "./components/NearMissCategoryListTable";

export default NearMissCategoryListTable;